export default __webpack_public_path__ + "static/media/present-a-new-project-idea.704d5e3b.pdf";